import { useCallback, useContext } from 'react';

import { CalculatorContext } from '@/context/calculator';
import { combineLinkWithParameters } from '@/utils/combine-link-with-parameters';

interface OutEvent {
    preventDefault?: () => void;
}

type useOutCallback = (event: OutEvent) => Promise<void>;

export const useOut = (_?: string, affiliate?: Graphql.Firm['affiliate']): useOutCallback => {
    const calculator = useContext(CalculatorContext);

    const redirect = useCallback<useOutCallback>(
        async (event) => {
            event?.preventDefault?.();

            if (affiliate) {
                window.open(affiliate, '_blank');

                return;
            }

            const fiizy = new URL('https://form.prestalo.com/');

            fiizy.searchParams.set('utm_origin', 'landing');
            fiizy.searchParams.set('cksAccepted', document.cookie.includes('CookieConsent').toString());

            if (calculator.fields.amount) {
                fiizy.searchParams.set('applicationPrincipal', calculator.fields.amount.toString());
            }

            if (calculator.fields.time) {
                fiizy.searchParams.set('applicationPeriod', calculator.fields.time.toString());
            }

            window.open(combineLinkWithParameters(fiizy.toString()), '_blank');
        },
        [calculator.fields, affiliate],
    );

    return redirect;
};
